<div class="icon-title-ingress-and-cta">
  <img
    class="icon"
    *ngIf="content?.fields.icon"
    [src]="content?.fields.icon.fields.file.url"
    [alt]="content?.fields.icon.fields.description || ''"
    loading="lazy"
  />
  <h3 class="title">{{ content?.fields.title }}</h3>
  <div class="ingress" [innerHTML]="content?.fields.ingress | richTextToHtml"></div>
  <a class="cta" [routerLink]="content?.fields.buttonLink">
    {{ content?.fields.buttonText }}
  </a>
</div>
